export default __webpack_public_path__ + "static/service6-f676779194791aba11dce377785ac0ef.png";